import api from './api';

export async function uploadExcelFile(token, file) {
  const formData = new FormData();
  formData.append('file', file);
  const response = await api.post('/import/excel', formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    },
  });

  console.log('Excel upload response:', response);
  return response.data;
}
